module.exports = __webpack_public_path__ + "static/about-image-1_m-8c36f5f8c3dc28e5d373b45315775683.jpg";